import { apiSlice } from "../../app/api/apiSlice";

export const uploadXmlHistoryApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		uploadXmlHistory: builder.mutation({
			query: (credentials) => {
				// Support both plain objects and real FormData for tpo_user_id
				const tpoUserId = credentials?.formData instanceof FormData
					? credentials.formData.get("tpo_user_id")
					: credentials?.formData?.tpo_user_id ?? credentials?.tpo_user_id;
				const page = credentials?.page;
				const pageSize = credentials?.pageSize;
				const filters = credentials?.filters || {};

				if (!tpoUserId) {
					throw new Error("tpo_user_id is required for uploadXmlHistory");
				}

				const params = { tpo_user_id: tpoUserId };
				if (page && Number(page) > 1) params.page = page;
				if (pageSize) params.page_size = pageSize;
				// append filter params only when provided
				Object.entries(filters).forEach(([key, value]) => {
					if (value !== undefined && value !== null && value !== "") {
						params[key] = value;
					}
				});

				return {
					url: "/api/v1/loan/pending_applications",
					method: "GET",
					params,
				};
			},
		}),
	}),
});

export const { useUploadXmlHistoryMutation } = uploadXmlHistoryApiSlice;